import { useQuery } from "@tanstack/react-query";
import { useApp } from "./use-app";
import { useEffect, useMemo } from "react";
import dayjs from "dayjs";
import { axios } from "lib/axios";
import { navigate } from "wouter/use-location";

const search = new URLSearchParams(window.location.search);

const useMaintenance = () => {
  const { app } = useApp()
  const { data, isLoading } = useQuery<{
    result: 'maintenance' | 'ok' | 'error';
    retry_after: string;
  }>({
    queryKey: ["app-status"],
    queryFn: () =>
      axios
        .get(`app-health/${app.id}`)
        .then((res) => res.data),
  });

  const formattedRetryAfter = useMemo(() => {
    if (!data?.retry_after) return ''
    return dayjs(data.retry_after).format('dddd D MMMM, HH:mma [GMT]Z')
  }, [data])

  useEffect(() => {
    if (isLoading || !data) return

    // We handle pocket login differently because
    // appUrl of pocket is /mobile-login which is used for deep linking
    // Actual login url can be viewed in pocket/config.json
    if (app.id === 'rex_crm_mobile') {
      // We store this because IOS and Android have different redirect_url
      const redirectUrl = search.get('redirect_url');
      // When in maintenance page
      if (location.pathname.includes('maintenance')) {
        if (data.result === 'ok') {
          window.location.href = 
            // Remove /mobile-login
            app.appUrl.replace('/mobile-login', '') + 
            '?app_id=rex_crm_mobile' +
            (redirectUrl ? `&redirect_url=${redirectUrl}` : '');
        }
      // When in login page
      } else if (data.result === 'maintenance') {
        navigate(`/maintenance${(redirectUrl ? `?redirect_url=${redirectUrl}` : '')}`)
      }
    } else {
      // When in maintenance page
      if (location.pathname.includes('maintenance')) {
        if (data.result === 'ok') {
          window.location.href = app.appUrl;
        }
      // When in login page
      } else if (data.result === 'maintenance') {
        navigate('/maintenance')
      }
    }
  }, [isLoading, data])

  return { data, isLoading, retryAfter: formattedRetryAfter, app }
}

export default useMaintenance
